import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=c5aa1146&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5aa1146')) {
      api.createRecord('c5aa1146', component.options)
    } else {
      api.reload('c5aa1146', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=c5aa1146&", function () {
      api.rerender('c5aa1146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/partials/Footer.vue"
export default component.exports